import { AUTH_ROUTES } from '../../constants/_routes'
import authTypes from '../../constants/authTypes'
import { axios } from '../../services'

import {
  capitalize
} from '../../helpers'
//
const confirm_request = () => {
  return {
    type: authTypes.CONFIRM.request
  }
}

const confirm_success = () => {
  return {
    type: authTypes.CONFIRM.success
  }
}

const confirm_failure = (messages) => {
  return {
    type: authTypes.CONFIRM.failure,
    payload: messages
  }
}

const confirm_token = (token) => {
  return function (dispatch) {
    // Before Request
    dispatch(confirm_request())

    // Request
    axios.get(
      AUTH_ROUTES.confirm,
      {
        params: {
          confirmation_token: token
        }
      }
    ).then( response => {
      // success
      dispatch( confirm_success() )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        // console.log("1")
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        const errdata = error.response.data
        if (errdata.constructor === Object) {
          errors = Object.keys(errdata).map( key => {
            return `${capitalize(key)} ${errdata[key][0]}`
          })
        } else if (errdata.constructor === Array) {
          errors = errdata
        } else {
          errors = ["Error confirming account"]
        }
      } else {
        errors = ["Error confirming account"]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( confirm_failure(errors))
    })
  }

}

export {
  confirm_token
}



// WEBPACK FOOTER //
// ./src/js/actions/users/confirm.js